// aws-exports.js
// AWS Cognito configuration for Amplify v6.
//
// Dev and prod use SEPARATE Cognito user pools (option C) so passkeys can be
// configured per-domain (WebAuthn RP ID is one domain per pool):
//   - 'dev'        -> dev pool  us-east-1_wEsRP3HbT (RP ID dev123bimlive.com)
//   - 'production' -> prod pool us-east-1_C0fdh1u5t
//   - 'local'      -> prod pool (the local backend validates against the prod pool)
//
// REACT_APP_DEPLOY_TARGET is injected at build time by the deploy tools
// ('dev' | 'production'); unset locally -> 'local'. Same convention as API/api.jsx.
//
// ⚠ PREREQUISITES before deploying this to the dev stack:
//   1. Dev users must exist in the dev pool (it starts empty).
//   2. The dev BACKEND must validate tokens against the dev pool — auth_routes.py
//      currently hardcodes the prod pool (us-east-1_C0fdh1u5t); make it env-aware.
const ENVIRONMENT = process.env.REACT_APP_DEPLOY_TARGET || 'local';
const useDevPool = ENVIRONMENT === 'dev';

const awsconfig = {
  Auth: {
    Cognito: {
      userPoolId: useDevPool ? 'us-east-1_wEsRP3HbT' : 'us-east-1_C0fdh1u5t',
      userPoolClientId: useDevPool ? '51pjpejm29otd1k27acvo8kdj4' : '25hfbmls764po68odtpdoqngpm',
      // v6: no mandatorySignIn / authenticationFlowType here — the auth flow is
      // chosen per signIn() call (default USER_SRP_AUTH; USER_AUTH for passkeys).
    },
  },
};

export default awsconfig;
